<div id="default-calendar">
    <div #calendarContainer></div>
    <button
        class="btn btn-dark d-flex flex-row align-items-center"
        (click)="goToToday()"
    >
        {{ 'today' | translate }}
    </button>
</div>
